
































































































import { Vue, Component } from 'vue-property-decorator';
import LineIcon from '@/components/svg/LineIcon.vue';
import firebase from 'firebase/app';
import 'firebase/database';
import { vxm } from '@/store';

@Component({
  components: {
    LineIcon,
  },
})
export default class extends Vue {
  private ref?: firebase.database.Reference;
  private step = '0';
  private testUrl = '';
  private summaryUrl = '';

  mounted() {
    this.ref?.off();
    this.ref = firebase.database().ref(`pr/new-user/${vxm.login.getUserId}`);
    this.ref.on('value', snapshot => {
      const userData = snapshot.val();
      if (userData) {
        if (this.step !== userData.step.slice(-1)) {
          this.step = userData.step.slice(-1);
        }
        if (userData.testUrl && userData.testUrl !== '') {
          this.testUrl = userData.testUrl;
        }
        if (userData.summaryUrl && userData.summaryUrl !== '') {
          this.summaryUrl = userData.summaryUrl;
        }
      }
    });
  }

  private async changeStep(step: string) {
    await this.ref?.update({
      step: step,
    });
  }

  private async finished() {
    const newRef = firebase.database().ref('pr/new-user');
    await newRef.update({
      [vxm.login.getUserId]: null,
    });
    this.$router.replace('/');
  }
}
